<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Iniciar Processo Seletivo</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Iniciar Processo Seletivo</b></h2>
                    </div>

                    <div class="mold-txt-center" v-if="!cpfVerificado">
                        <form ref="colaborador-form-create" v-on:submit.prevent novalidate>
                            <div class="row justify-content-center">
                                <div class="col-md-auto">
                                    <div class="form-group">
                                        <label for="cpf">Digite o CPF do candidato</label>
                                        <input type="text" class="form-control" name="cpf" v-mask="mask_cpf" maxlength="14" autocomplete="off" placeholder="___.___.___-__" v-model="cpfBusca" required />
                                    </div>
                                    <button type="button" class="btn btn-success " @click="verificarCPF()">
                                        <span>Verificar</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="mold-txt-center" v-if="cpfVerificado">
                        <form-create-colaborador :cpf="cpfBusca" @on-saved="openCriarTeste" @on-back="onBack" />
                    </div>

                </div>
            </div>
        </section>

        <!--confirmação de novo colaborador-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogConfirmacaoAcao" :hide-footer="true" title="Confirmação">
            <div class="row">
                <section class="col-md-12" v-if="!colaborador">
                    O CPF não foi encontrado na nossa base.
                </section>
                <section class="col-md-12" v-if="colaborador && !ehColaboradorNaEscolaAtual">
                    CPF encontrado na nossa base.<br />
                    <br />
                    <strong>Escola:</strong> {{escolaNome}}
                    <br />
                    <strong>Candidato:</strong> {{ colaborador.nmCompleto.toUpperCase() }}
                    <a :href="urlColaborador" target="_blank" title="Consultador dados do colaborador" class="pull-right">
                        clique aqui <i class="fa fa-external-link"></i>
                    </a>
                    <br />
                    <br />
                </section>
                <section class="col-md-12" v-if="ehColaboradorNaEscolaAtual">
                    O Colaborador já possui um teste aprovado (contratado) em sua escola.
                    <b> Caso opte por seguir, será gerado um novo teste. Essa ação não afetará a APROVAÇÃO já existente.</b>
                    <br />
                    <br />
                    <strong>Escola:</strong> {{escolaNome}}
                    <br />
                    <strong>Candidato:</strong> {{ colaborador.nmCompleto.toUpperCase() }}
                    <a :href="urlColaborador" target="_blank" title="Consultador dados do colaborador" class="pull-right">
                        clique aqui <i class="fa fa-external-link"></i>
                    </a>
                    <br />
                    <br />
                </section>
                <section class="col-md-12" v-if="ehCandidatoEmOutraEscola">
                    <div class="alert alert-warning">
                        <i class="fa fa-info-circle"></i> Este candidato está participando de um processo seletivo em uma outra Escola CNA.
                    </div>
                </section>
                <section class="col-md-12" v-if="ehColaboradorEmOutraEscola">
                    <div class="alert alert-danger">
                        <i class="fa fa-info-circle"></i> O candidato já é colaborador em outra escola.
                    </div>
                </section>
                <section class="col-md-12">
                    Deseja prosseguir com o processo?
                </section>
            </div>
            <br />
            <div class="row">
                <div class="col-md-6">
                    <br />
                    <button type="button" class="btn btn-default" @click="onBack()">
                        <span>Não, Voltar</span>
                    </button>
                </div>
                <div class="col-md-6">
                    <br />
                    <button type="button" class="btn btn-success" v-if="actionConfirmacaoAcao" @click="actionConfirmacaoAcao()">
                        <span>Sim, Quero Continuar</span>
                    </button>
                </div>
            </div>
        </b-modal>

        <!--form nova candidatura cargo-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogCandidato" :hide-footer="true" title="Confirmação de Candidatura">
            <p v-if="colaborador">
                <strong>Escola:</strong> {{escolaNome}}<br />
                <strong>Candidato:</strong> {{ colaborador.nmCompleto.toUpperCase() }}
                <a :href="urlColaborador" target="_blank" title="Consultar dados do colaborador" class="pull-right">
                    clique aqui <i class="fa fa-external-link"></i>
                </a>
            </p>
            <form-create-candidato v-if="dialogCandidato && colaborador" :escola-id="escolaLogadaId" :colaborador-id="colaborador.colaboradorId" @on-saved="openLiberarTeste" @on-back="onBack" />
        </b-modal>

        <!--form liberar realização do teste-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogLiberarTeste" :hide-footer="true" title="Realização do teste">
            <form-liberar-teste v-if="dialogLiberarTeste" :id="candidato.candidatoId" @on-saved="openRealizarTeste" @on-back="onBack" />
        </b-modal>

        <!--form liberar realização da entrevista-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogLiberarEntrevista" :hide-footer="true" title="Realização da entrevista">
            <form-liberar-entrevista v-if="dialogLiberarEntrevista" :id="candidato.candidatoId" @on-saved="openRealizarEntrevista" @on-back="onBack" />
        </b-modal>

        <!--form entrevista-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogRealizarEntrevista" :hide-footer="true" title="Realizar Entrevista">
            <form-realizar-entrevista v-if="dialogRealizarEntrevista" :candidatoId="candidato.candidatoId" :entrevistaId="candidato.entrevistaId" @on-saved="openConfigurarLiberacao" @on-back="onBack" />
        </b-modal>

        <!--configuração da liberação de acesso-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogConfigurarAcesso" :hide-footer="true" title="Configurar Novo Colaborador">
            <form-configurar-acesso v-if="dialogConfigurarAcesso" :candidatoId="candidato.candidatoId" @on-back="onBack" />
        </b-modal>

    </main>

</template>
<script>

    import { Api } from '@/common/api'
    import auth from '@/common/auth'
    import base from '@/common/base.js'

    import formCreateColaborador from '@/views/colaborador/form-create'
    import formCreateCandidato from '@/views/candidato/form-create'
    import formLiberarTeste from '@/views/candidato/form-liberar-teste'
    import formLiberarEntrevista from '@/views/candidato/form-liberar-entrevista'
    import formRealizarEntrevista from '@/views/candidato/form-realizar-entrevista'
    import formConfigurarAcesso from '@/views/candidato/form-configurar-acesso'

    export default {
        name: 'iniciarprocessoseletivo',
        mixins: [base],
        components: {
            formCreateColaborador,
            formCreateCandidato,
            formConfigurarAcesso,
            formLiberarTeste,
            formLiberarEntrevista,
            formRealizarEntrevista
        },
        data() {
            return {
                user: { escolas: [] },
                cpfBusca: '',
                escolaLogadaId: 0,
                cpfVerificado: false,

                dialogLiberarTeste: false,
                dialogCandidato: false,
                dialogLiberarEntrevista: false,
                dialogConfirmacaoAcao: false,
                dialogRealizarEntrevista: false,
                dialogConfigurarAcesso: false,

                ehCandidatoEmOutraEscola: false,
                ehColaboradorNaEscolaAtual: false,
                ehColaboradorEmOutraEscola: false,
                actionConfirmacaoAcao: null,

                candidato: null,
                colaborador: null,
                form: "colaborador-form-create",
            }
        },
        computed: {
            urlColaborador: function () {
                if (!this.colaborador) return '';
                return '/colaborador/details/' + this.colaborador.colaboradorId + '/?tab=3'
            },
            escolaNome() {
                var escola = this.user.escolas.filter(_ => _.escolaId == this.escolaLogadaId)[0];
                if (escola) return escola.nomeEscola
                return "--";
            }
        },
        methods: {

            verificarCPF: function () {
                new Api('colaborador/verificacpfcolaborador').get({
                    cpf: this.cpfBusca.replace(/\D+/g, '')
                }).then(result => {

                    let _data = result.data;

                    this.candidato = null;
                    this.colaborador = null;
                    this.ehCandidatoEmOutraEscola = false;
                    this.ehColaboradorNaEscolaAtual = false;
                    this.ehColaboradorEmOutraEscola = false;

                    if (!_data || _data.colaboradorNaoEncontrado) {
                        this.actionConfirmacaoAcao = this.openNovoCandidato;
                        this.dialogConfirmacaoAcao = true;
                    }
                    else {

                        this.onBack();

                        this.colaborador = _data.colaborador;
                        this.ehCandidatoEmOutraEscola = _data.ehCandidatoEmOutraEscola;
                        this.ehColaboradorEmOutraEscola = _data.ehColaboradorEmOutraEscola;

                        this.actionConfirmacaoAcao = this.openCriarTeste;
                        this.dialogConfirmacaoAcao = true;

                        this.ehColaboradorNaEscolaAtual = _data.ehColaboradorNaEscolaAtual;
                    }

                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            openNovoCandidato: function () {
                this.dialogConfirmacaoAcao = false;
                this.cpfVerificado = true;
            },

            openCriarTeste: function (colaborador) {
                if (colaborador) this.colaborador = colaborador;
                this.dialogCandidato = true;
            },

            openLiberarTeste: function (candidato) {
                this.candidato = candidato;
                if (this.candidato.contratado) {
                    this.onBack()
                    return;
                }
                if (this.candidato.reaproveitado)
                    this.dialogLiberarEntrevista = true;
                else
                    this.dialogLiberarTeste = true;
            },

            openRealizarEntrevista: function (candidato) {
                this.candidato = candidato;
                this.dialogRealizarEntrevista = true;
            },

            openRealizarTeste: function (candidato) {

                var token = auth.getAccessToken();
                var candidatoId = candidato.candidatoId;
                var testeId = candidato.testeId;

                var routeData = this.$router.resolve({
                    path: '/teste-realizar/' + candidatoId + '/' + testeId + '/' + this.colaborador.cpf.replace(/\D+/g, '') + '/?accesstoken=' + token
                });

                var params = [
                    'height=' + screen.availHeight,
                    'width=' + screen.availWidth,
                    'fullscreen=yes'
                ].join(',');

                var popup = window.open(routeData.href, "newWin", params);
                if (popup.outerWidth < screen.availWidth || popup.outerHeight < screen.availHeight) {
                    popup.resizeTo(screen.availWidth, screen.availHeight);
                    popup.moveTo(0, 0);
                }

                if (window.location.origin.indexOf("localhost") == -1)
                    auth.logout();

            },

            openConfigurarLiberacao: function (data) {
                this.onBack();
                if (data && data.doOpenConfigurarAcesso) {
                    new Api('candidato').get({ id: this.candidato.candidatoId }).then(data => {
                        if (data.data.situacaoCandidatoId == 1)
                            this.dialogConfigurarAcesso = true;
                    });
                }
            },

            onBack: function () {
                this.colaborador = null;
                this.cpfVerificado = false;
                this.dialogCandidato = false;
                this.dialogConfirmacaoAcao = false;
                this.dialogLiberarTeste = false;
                this.dialogLiberarEntrevista = false;
                this.dialogRealizarEntrevista = false;
                this.dialogConfigurarAcesso = false;
                this.ehCandidatoEmOutraEscola = false;
                this.ehColaboradorNaEscolaAtual = false;
                this.ehColaboradorEmOutraEscola = false;
                this.cpfBusca = '';
            }

        },

        mounted() {
            this.user = auth.currentUser();
            this.escolaLogadaId = +auth.currentUser().tenant;
        }

    };
</script>